angular.module('accessWebClient').directive('accMainColorSvgFilter', [
    'DefaultMainColor',
    'MainColor',
    function (DefaultMainColor, MainColor) {
        /**
         * Return color component coefficient relative to
         * an appropriate DefaultMainColor component
         * @param {number} component Color component value
         * @param {('R' | 'G' | 'B')} name Component name
         * @return {string} Formatted coefficient
         */
        function colorCoefficient(component, name) {
            var defaultColorComponentValue;
            switch (name) {
                case 'R':
                    defaultColorComponentValue = DefaultMainColor[0];
                    break;
                case 'G':
                    defaultColorComponentValue = DefaultMainColor[1];
                    break;
                case 'B':
                    defaultColorComponentValue = DefaultMainColor[2];
                    break;
            }
            return (component / defaultColorComponentValue).toFixed(3);
        }

        return {
            scope: {},
            replace: true,
            link: function ($scope) {
                var mainColor = MainColor.get();
                var matrix =
                    colorCoefficient(mainColor[0], 'R') +
                    ' 0 0 0 0' +
                    ' 0 ' +
                    colorCoefficient(mainColor[1], 'G') +
                    ' 0 0 0' +
                    ' 0 0 ' +
                    colorCoefficient(mainColor[2], 'B') +
                    ' 0 0' +
                    ' 0 0 0 1 0';
                angular.element('filter#accMainColor feColorMatrix').attr('values', matrix);
            },
            template: '<acc-svg-definition>' +
                '<filter id="accMainColor" color-interpolation-filters="sRGB">' +
                    '<feColorMatrix type="matrix" values="" />'     +
                '</filter>' +
            '</acc-svg-definition>'
        };
    }
]);
